import { Button, Container, Form, Modal, Spinner } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import phoneIcon from 'assets/images/login-call.svg'
import loginStep1 from 'assets/images/login-step1.svg'
import BaseModal from './BaseModal'
import { useRequestOTP } from 'dataLayer/user'
import { useDispatch } from 'react-redux'
import { showSnackbar } from 'store/actions'

function LoginOTPModal({
	show,
	onHide,
	onShowLogin,
	onShowOTP,
	phone,
	setPhone,
	...otherProps
}) {
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const { mutate, isLoading } = useRequestOTP(onShowOTP)

	function handleRequestOTP() {
		if (!phone) {
			dispatch(showSnackbar(true, t('modal.login.otp_error'), 'error'))
		} else {
			mutate({ msisdn: phone })
		}
	}

	function handlePhoneInput(e) {
		setPhone(e.target.value)
	}

	return (
		<>
			<BaseModal show={show} onHide={onHide} {...otherProps}>
				<Container fluid className="baseinput-container">
					<Modal.Header>
						<Modal.Title
							id="contained-modal-title-vcenter"
							className="login-otp-title"
						>
							{t('modal.login.title_OTP')}
						</Modal.Title>
						<Modal.Body>
							<img
								src={loginStep1}
								alt="Login step 1"
								className="mx-auto mb-3"
							/>
							<p>{t('modal.login.desc')}</p>
						</Modal.Body>
					</Modal.Header>
					<Modal.Body>
						<Form>
							<Form.Group className="mb-3 base-input">
								<img src={phoneIcon} alt="" />
								<Form.Control
									type="phone"
									value={phone}
									onChange={handlePhoneInput}
									id="msisdn"
									placeholder={t('modal.form.phone')}
								/>
							</Form.Group>
						</Form>
					</Modal.Body>
					<Modal.Footer>
						<Button
							variant="secondary"
							disabled={isLoading}
							onClick={handleRequestOTP}
						>
							{t('modal.login.login_otp_btn')}
							{isLoading ? (
								<Spinner animation="border" role="status"></Spinner>
							) : null}
						</Button>
						<Button variant="dark" onClick={onShowLogin}>
							{t('modal.login.login_pass')}
						</Button>
						<Button variant="dark">{t('modal.login.login_UniID')}</Button>
					</Modal.Footer>
				</Container>
			</BaseModal>
		</>
	)
}

export default LoginOTPModal
